<template>
  <div class="home">
    <Banner />
    <State />
    <Resource />
    <DistributionTools />
    <Cruise />
    <CompanyScroll />
    <Contact />
    <FixedHoverNav />
  </div>
</template>
<script>
import { throttle, getScreenWH } from "@/utils/helpers.js";
import Banner from "~/views/home/Banner.vue";
import State from "~/views/home/State.vue";
import DistributionTools from "~/views/home/DistributionTools.vue";
import Cruise from "~/views/home/Cruise.vue";
import CompanyScroll from "~/views/home/CompanyScroll.vue";
import Contact from "~/views/home/Contact.vue";
import Resource from "~/views/home/Resource.vue";
import FixedHoverNav from "~/components/FixedHoverNav.vue";

export default {
  name: "Home",
  layout: "MainHome",
  auth: false,
  head: {
    title: "上船吧 专业的“邮轮+高端旅游”商家服务平台",

    meta: [
      {
        name: 'google-site-verification',
        content: 'IxcgXOpon0QYPQf6xiWxJF_RAC2DqvLROT8Qi6mJj2g'
      },
      {
        name: "viewport",
        content: "width=device-width, initial-scale=1, maximum-scale=1",
      }, 
      {
        hid: 'description',
        name: 'description',
        content: `【上船吧】（www.shangchuanba.com），致力于打造全球最大、最专业的邮轮平台，中国高端旅游资源整合运营商。从长江游轮起步，未来基于国内外河轮、江轮、母港邮轮业务，打造水上旅游领域垂直网络分销平台，与各家航运系统开通直连，为旅游企业、旅游从业者提供最便捷的销售、运营及管理工具 。`
      },
      {
        hid: 'keywords',
        name: 'keywords',
        content: `上船吧,分销平台,资源整合平台,商家服务,分销店铺,旅游,度假,邮轮,邮轮旅游,游轮,游轮旅游,邮轮度假,游轮度假,长江游轮,海洋邮轮,境内邮轮,河轮,海轮,境外河轮,游轮,极地邮轮,皇家加勒比,皇家,诺唯真,NCL,诺唯真游轮,公主邮轮,MSC,地中海邮轮,中船嘉年华,维京游轮,探索号,长江探索号,长江探索号游轮,世纪游轮,松赞,松赞旅行,长江叁号,新东方快车,北国列车,呼伦贝尔号,Club Med`
      }
    ],
  },
  components: {
    Banner,
    State,
    Resource,
    DistributionTools,
    Cruise,
    CompanyScroll,
    Contact,
    FixedHoverNav,
  },
};
</script>

<style lang="scss" scoped>

// @import "~@/assets/scss/pages/global/home";

</style>
